import axios from "axios/dist/axios";
import Requester from "../Requester.js";
import EventBus from "../../plugins/event-bus";
import i18n from "../../translations";
import router from "../../router";
import Utils from "../../utils";

const route = "quotes";
const name = "quoteUsa";
const nameItemQuote = "ItemQuote";
const nameQuotes = "Quotes";
const nameProduct = "Product";
const nameCostSale = "CostSale";
const nameSendOrder = "SendOrder";
const quotesApi = "venusa/cotacao";
const salesrepApi = "venusa/representante";
const productApi = "v1/quotation/resources";
const costSaleApi = "venusa/custo_venda";
const getters = {};
let simulador = JSON.parse(localStorage.getItem(name)) || {};
const emptyForm = {
  ID_IMPORTACAO: null,
  ADDRESS: null,
  CUST_PO_NUMBER: null,
  REQUEST_DATE: null,
  SHIP_INSTRUCTIONS: null,
  SALES_REP_NAME: null,
  TOTAL: 0,
  STATUS: 'A',
  FREIGHT_TERMS: 'Prepay & Add'
};
const state = {
  savingOrder: false,
  quote: simulador.form || emptyForm,
  clients: [],
  products: [],
  productsLines: [],
  productsLinesQtd: 0,
  items: simulador.items || [],
  lines: [],
  types: [],
  adresses: [],
  quotes: [],
  quotesQtd: 0,
  quotesLoading: true
};
let cancelarRequest = null;

const mutations = {
  cleanStateProduct(state) {
    state.products = [];
  },
  cleanState(state) {
    state.quote = simulador.form || emptyForm;
    state.clients = [];
    state.products = [];
    state.productsLines = [];
    state.productsLinesQtd = 0;
    state.items = simulador.items || [];
    state.lines = [];
    state.adresses = [];
    state.quotes = [];
    state.quotesQtd = 0;
    state.quotesLoading = true;
  },
  setParameters(state, payload) {
    const { list } = payload;
    state.clients = list.clientes || [];
    state.adresses = list.enderecos || [];
    state.quotesLoading = false;
    EventBus.$emit("change::isLoading", false);
  },
  setQuotes(state, payload) {
    const { list } = payload;
    state.quotes = list.lista || [];
    state.quotesQtd = list.count;
    state.quotesLoading = false;
    EventBus.$emit("change::isLoading", false);
  },
  setItemQuote(state, payload) {
    const { list } = payload;
    state.quote = list.pedido || {};
    state.items = list.itens || [];
    EventBus.$emit("change::isLoading", false);
  },
  setProduct(state, payload) {
    const { list } = payload;
    state.products = list.data?.products?.items || [];
    EventBus.$emit("change::isLoadingSearch", false);
  },
  setProductLine(state, payload) {
    const { list } = payload;
    let groupedItems = list.data?.products?.items || [];

    state.lines = list.data?.product_lines

    state.types = list.data?.product_types

    state.productsLines = Object.values(groupedItems.reduce((arr, item) => {
      if (!arr[item.URL_IMAGE]) {
        arr[item.URL_IMAGE] = {
          name: item.URL_IMAGE,
          items: []
        };
      }
      arr[item.URL_IMAGE].items.push(item);
      return arr;
    }, []));
    state.productsLinesQtd = list.data?.products?.total || 0;
    EventBus.$emit("change::isLoading", false);
  },
  setCostSale(state, payload) {
    const { list } = payload;
    list.products.forEach(product => {
      state.items = state.items.map(item => {
        if (item.TIGRE_CODE === product.TIGRE_CODE) {
          item = product;
          item.loading = false;
        }
        return item;
      });
    });
  },
  setSendOrder(state, payload) {
    const { list } = payload;
    EventBus.$emit("change::isLoading", false);
    let parameters = {
      snackbar: true,
      text: i18n.t(list.mensagem),
      color: "error"
    };
    if (list.sucesso) {
      localStorage.removeItem(name);
      parameters.color = "blue darken-4";
      router.push('/' + route);
    }
    mutations.setSavingOrder(state, false);
    EventBus.$emit("criarAlerta", parameters);
    EventBus.$emit("change::isLoading", false);
  },
  setAddress(state, payload) {
    state.adresses[payload.CUSTOMER].push(payload);
  },
  setSavingOrder(state, payload) {
    state.quote.UNIDADE_PAIS = Utils.loadCountry();
    state.savingOrder = payload;
  },
  prepareItens(state, payload) {
    const { items } = payload;
    items.forEach(product => {
      let update = false;
      state.items = state.items.map(item => {
        if (item.TIGRE_CODE === product.TIGRE_CODE) {
          item = product;
          item.loading = true;
          update = true;
        }
        return item;
      });
      if (!update) {
        product.loading = true;
        state.items.push(product);
      }
    });
  }
};

const actions = {
  async getParameters(context) {
    EventBus.$emit("change::isLoading", true);
    let request = { getParameters: true, unidadePais: Utils.loadCountry() };
    Requester.RequestGetAll(context, request, quotesApi, `setParameters`, null, "get");
  },
  async getAll(context, payload) {
    EventBus.$emit("change::isLoading", true);
    let request = {
      filterBy: payload.search,
      sortBy: payload.sortBy[0],
      sortAsc: payload.sortDesc[0] ? "DESC" : "ASC",
      limit: payload.itemsPerPage,
      offset: (payload.page - 1) * payload.itemsPerPage,
      unidadePais: Utils.loadCountry()
    };
    if (cancelarRequest) {
      cancelarRequest = cancelarRequest.cancel();
    }
    cancelarRequest = axios.CancelToken.source();
    Requester.RequestGetAll(context, request, quotesApi, `set${nameQuotes}`, null, "get", cancelarRequest);
  },
  async getById(context, salesQuote) {
    EventBus.$emit("change::isLoading", true);
    Requester.RequestGetAll(context, null, quotesApi + '/' + salesQuote, `set${nameItemQuote}`, null, "get");
  },
  async getProduct(context, payload) {
    EventBus.$emit("change::isLoadingSearch", true);
    let request = { 
      status: 'A',
      filter_by: {
        name: payload.search
      },
      sort_by: 'name',
      sort_asc: 'asc',
      limit: 30,
      customer: payload.customer,
      location: payload.location,
      unidade_pais: Utils.loadCountry()
    };
    if (cancelarRequest) {
      cancelarRequest = cancelarRequest.cancel();
    }
    cancelarRequest = axios.CancelToken.source();
    return Requester.RequestGetAll(context, request, productApi, `set${nameProduct}`, true, "get", cancelarRequest);
  },
  async getProductLine(context, payload) {
    EventBus.$emit("change::isLoading", true);
    if (payload.clean) {
      state.productsLines = [];
      state.productsLinesQtd = 0;
    }
    let request = { 
      status: 'A',
      filter_by: payload.search,
      sort_by: payload.sortBy[0],
      sort_asc: payload.sortDesc[0] ? "DESC" : "ASC",
      limit: payload.limit,
      offset: (payload.page - 1) * payload.limit,
      customer: payload.customer,
      location: payload.location,
      unidade_pais: Utils.loadCountry()
    };
    if (cancelarRequest) {
      cancelarRequest = cancelarRequest.cancel();
    }
    cancelarRequest = axios.CancelToken.source();
    return Requester.RequestGetAll(context, request, productApi, `set${nameProduct}Line`, true, "get", cancelarRequest);
  },
  async getSalesRepName(context, payload) {
    EventBus.$emit("change::isLoading", true);
    let salesrep = payload.salesrep
    
    let request = { 
      salesrep: salesrep,
      unidadePais: Utils.loadCountry()
    };
    if (cancelarRequest) {
      cancelarRequest = cancelarRequest.cancel();
    }
    cancelarRequest = axios.CancelToken.source();
    return Requester.RequestGetAll(context, request, `${salesrepApi}/getName/${salesrep}`, `setSalesRepName`, null, "getName", cancelarRequest);
  },
  async getCostSale(context, payload) {
    context.commit("prepareItens", payload);

    let params = Object.assign({}, payload);
    params.items = JSON.stringify(params.items);
    let request = new FormData();
    for (let key in params) {
      if (params[key]) {
        request.append(key, params[key]);
      }
    }
    Requester.RequestGetAll(context, request, costSaleApi, `set${nameCostSale}`, null, "post");
  },
  async getSendOrder(context, payload) {
    EventBus.$emit("change::isLoading", true);
    let params = Object.assign({}, payload);
    let url = quotesApi;
    if (params.SALES_ORDER_ID) {
      url += "/" + params.SALES_ORDER_ID;
    }
    params.ITENS = JSON.stringify(params.ITENS);
    params.ADDRESS = JSON.stringify(params.ADDRESS);
    params.CUSTOMER = JSON.stringify(params.CUSTOMER);
    let request = new FormData();
    for (let key in params) {
      if (params[key]) {
        request.append(key, params[key]);
      }
    }
    Requester.RequestGetAll(context, request, url, `set${nameSendOrder}`);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
